module.exports = __webpack_public_path__ + "img/document_corrected.e2e5717d.svg";